<template>
   <div class="server">
       <div class="server_h3">运费服务说明</div>
       <div class="server_content">
            <p>1.会员下单如包含需在线付运费商品，订单中会显示运费金额，会员需支付商品+运费总金额；</p>
            <p>2.平台运费标准分为三档，大件类70元/件、中间类30元/件、小件类10元/件，其中大件和中件商品运费根据采购量累计叠加计算，小件类商品运费不再根据采购量叠加计算；</p>
            <p>3.中、小件商品运费100元封顶；</p>
            <p>4.大、中、小件商品订单实付不满5万，中、小件商品运费100元封顶，大件商品运费叠加收取；大、中、小件商品订单实付满5万，中、小件商品运费100元封顶，大件商品运费五折收取；大、中、小件商品订单实付满10万，免运费；</p>
            <p>5.超大型设备订单运费可联系在线客服联系协商具体物流价格；</p>
            <p>6.批量采购的订单运费可联系在线客服联系协商具体物流价格；大件类：空调主机、空调室内机、壁挂锅炉、新风主机、水箱、中央软水机、中央净水机等设备；中件类：钢制散热片、管材、水泵、耦合罐、分集水器等；小件类：各类管接件、阀门、配套辅材等；</p>
            <p>7.会员在收货时，必须对商品外包装箱体进行完好性检查，特别是对于壁挂炉等外观性要求高的商品必须开箱检查，确认无误后再完成签收，货损风险转移到接收方；</p>
            <p>8.会员选择自提的商品，在商品出库时必须对商品外包装箱体进行完好性检查，特别是对于壁挂炉等外观性要求高的商品必须开箱检查，确认无误后再完成签收，货损风险转移到接收方；</p>
            <p>9.运费不含上楼及卸货费用；</p>
            <p>10.因会员方收货人员未能按照约定的收货时间到达收货地收货，延误收货时间，造成物流方等候费用由会员方承担。</p>
            <p>11.会员在当日15:30前下单的，物流到货时间将会根据物流情况以次日到或隔日到两种方式，不接受会员当日下单当日到或指定几点钟前必须到货等配送要求</p>
       </div>
   </div>
</template>
<script>
export default {
    name: 'freightServer',
    data () {
        return {
            title: '运费收费说明'
        }
    }
}
</script>
<style lang="scss" scoped>
.server{
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 42px;
    padding: 56px 28px 32px;
    &_h3{
        text-align: center;
        margin-bottom: 32px;
        font-size: 34px;
        line-height: 48px;
    }
    &_content {
        font-size: 30px;
        color: #333;
        max-height: 400px;
        overflow-y: scroll;
    }
}
</style>